import { render } from "./AllCategory.vue?vue&type=template&id=f9c6ce58"
import script from "./AllCategory.vue?vue&type=script&lang=js"
export * from "./AllCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__